export default [
  // 主页 - 仪表盘
  {
    path: '/crm/home-header',
    name: 'CrmHomeHeader',
    component: () => import(/* webpackChunkName: 'CrmChartHome' */ '@/views/crm/home/header.vue'),
  },
  // 主页 统计表
  {
    path: '/crm/statistics/table',
    name: 'CrmStatisticsTable',
    component: () => import(/* webpackChunkName: 'CrmStatisticsTable' */ '@/views/crm/statistics/table.vue'),
  },
  // 主页 统计图
  {
    path: '/crm/statistics/figure',
    name: 'CrmStatisticsFigure',
    component: () => import(/* webpackChunkName: 'CrmStatisticsFigure' */ '@/views/crm/statistics/figure.vue'),
  },
  // 销售统计
  {
    path: '/crm/sale-data',
    name: 'CrmSaleData',
    component: () => import(/* webpackChunkName: 'CrmSaleData' */ '@/views/crm/sale-data/index.vue'),
  },
  // 客户统计
  {
    path: '/crm/customer-data',
    name: 'CrmCustomerData',
    component: () => import(/* webpackChunkName: 'CrmCustomerData' */ '@/views/crm/customer-data/index.vue'),
  },
  // 统计表 - 月份目标记录
  {
    path: '/crm/statistics/month-record-detail',
    name: 'CrmStatisticsMonthRecordDetail',
    component: () => import(/* webpackChunkName: 'CrmStatisticsMonthRecordDetail' */ '@/views/crm/statistics/month-record-detail.vue'),
  },
  // 统计表 - 预设目标详情
  {
    path: '/crm/statistics/preset-month-record-detail',
    name: 'CrmStatisticsPresetMonthRecordDetail',
    component: () => import(/* webpackChunkName: 'CrmStatisticsPreSetMonthRecordDetail' */ '@/views/crm/statistics/preset-month-record-detail.vue'),
  },
  // 统计表 - 完成率
  {
    path: '/crm/statistics/completion-rate',
    name: 'CrmStatisticsCompletionRate',
    component: () => import(/* webpackChunkName: 'CrmStatisticsCompletionRate' */ '@/views/crm/statistics/completion-rate.vue'),
  },
  // 统计表 - 月份目标记录
  {
    path: '/crm/statistics/month-record',
    name: 'CrmStatisticsMonthRecord',
    component: () => import(/* webpackChunkName: 'CrmStatisticsMonthRecord' */ '@/views/crm/statistics/month-record.vue'),
  },
  // 统计图 - 目标完成趋势-折线图 (暂时没有使用 2020.11.10)
  {
    path: '/crm/statistics/smoothed-line',
    name: 'CrmStatisticsSmoothedLine',
    component: () => import(/* webpackChunkName: 'CrmStatisticsSmoothedLine' */ '@/views/crm/statistics/smoothed-line.vue'),
  },
  // 统计图 - 目标完成趋势-柱状图
  {
    path: '/crm/statistics/histogram',
    name: 'CrmStatisticsHistogram',
    component: () => import(/* webpackChunkName: 'CrmStatisticsHistogram' */ '@/views/crm/statistics/histogram.vue'),
  },
  // 数据分析 - 销售数据 - 折线图
  {
    path: '/crm/sale-data/smoothed-line',
    name: 'CrmSaleDataSmoothedLine',
    component: () => import(/* webpackChunkName: 'CrmSaleDataSmoothedLine' */ '@/views/crm/sale-data/smoothed-line.vue'),
  },
  // 数据分析 - 客户数据 - 折线图
  {
    path: '/crm/customer-data/smoothed-line',
    name: 'CrmCustomerDataSmoothedLine',
    component: () => import(/* webpackChunkName: 'CrmCustomerDataSmoothedLine' */ '@/views/crm/customer-data/smoothed-line.vue'),
  },
  // 数据分析 - 销售数据 - 客户销售排名
  {
    path: '/crm/sale-data/customer-sale-rank',
    name: 'CrmSaleDataCustomerSaleRank',
    component: () => import(/* webpackChunkName: 'CrmSaleDataCustomerSaleRank' */ '@/views/crm/sale-data/customer-sale-rank.vue'),
  },
  // 销售统计订单详情
  {
    path: '/crm/sale-detail/sale-order-detail',
    name: 'CrmSaleDetailSaleOrderDetail',
    component: () => import(/* webpackChunkName: 'CrmStatisticsFigure' */ '@/views/crm/sale-detail/sale-order-detail.vue'),
  },
  // 销售统计售后详情
  {
    path: '/crm/sale-detail/after-sale-detail',
    name: 'CrmSaleDetailAfterSaleDetail',
    component: () => import(/* webpackChunkName: 'CrmStatisticsFigure' */ '@/views/crm/sale-detail/after-sale-detail.vue'),
  },
  // 垫付统计
  {
    path: '/crm/demand-analysis/index',
    name: 'CrmDemandAnalysis',
    component: () => import(/* webpackChunkName: 'CrmDemandAnalysis' */ '@/views/crm/demand-analysis/index.vue'),
  },
  // 需求分析 - 需求关闭原因&未下大货原因&客户确认结果&匹配无结果
  {
    path: '/crm/demand-analysis/pie',
    name: 'CrmDemandAnalysisPie',
    component: () => import(/* webpackChunkName: 'CrmDemandAnalysisPie' */ '@/views/crm/demand-analysis/pie'),
  },
  // 需求分析 - 需求转化率（下大货&下剪版）
  {
    path: '/crm/demand-analysis/funnel',
    name: 'CrmDemandAnalysisFunnel',
    component: () => import(/* webpackChunkName: 'CrmDemandAnalysisFunnel' */ '@/views/crm/demand-analysis/funnel'),
  },
  // 版房净色统计 - 趋势图
  {
    path: '/crm/cloud-room-pure-demand-analysis/trend',
    name: 'CloudRoomPureDemandAnalysisTrend',
    component: () => import(/* webpackChunkName: 'CloudRoomPureDemandAnalysisTrend' */ '@/views/crm/cloud-room-pure-demand-analysis/trend'),
  },
  // 垫付统计 - 使用率趋势
  {
    path: '/crm/advance-statistics/trend',
    name: 'CrmAdvanceStatisticsTrend',
    component: () => import(/* webpackChunkName: 'CrmAdvanceStatisticsTrend' */ '@/views/crm/advance-statistics/trend.vue'),
  },
  // 垫付统计 - 逾期占在途金额比例
  {
    path: '/crm/advance-statistics/proportion',
    name: 'CrmAdvanceStatisticsProportion',
    component: () => import(/* webpackChunkName: 'CrmAdvanceStatisticsProportion' */ '@/views/crm/advance-statistics/proportion.vue'),
  },
  // 数据分析 - 供应商数据 - 供应商排名
  {
    path: '/crm/supplier-data',
    name: 'SupplierData',
    component: () => import(/* webpackChunkName: 'CrmSaleDataCustomerSaleRank' */ '@/views/crm/supplier-data/index'),
  },
  // 数据分析 - 供应商数据 - 商品排名
  {
    path: '/crm/supplier-data/commodity-rank',
    name: 'CommodityRank',
    component: () => import(/* webpackChunkName: 'CrmSaleDataCustomerSaleRank' */ '@/views/crm/supplier-data/commodity-rank'),
  },
  // 数据分析 - 供应商数据 - 城市排名
  {
    path: '/crm/supplier-data/city-rank',
    name: 'CityRank',
    component: () => import(/* webpackChunkName: 'CrmSaleDataCustomerSaleRank' */ '@/views/crm/supplier-data/city-rank'),
  },
  // 统计 - 需求统计 - 发布需求趋势
  {
    path: '/crm/statistical-data/demand-statistical',
    name: 'DemandStatistical',
    component: () => import(/* webpackChunkName: 'DemandStatistical' */ '@/views/crm/demand-statistical/broken-line'),
  },
  // BD日报统计
  {
    path: '/crm/daily-statistics',
    name: 'DailyStatistics',
    component: () => import(/* webpackChunkName: 'DailyStatistics' */ '@/views/crm/daily-statistics'),
  },
];
